module.exports = __webpack_public_path__ + "static/media/nynfc2.2e5c2120.jpg";